
export interface ApplicationListItem {
    ItemId: number;
    Description: string;
    VisionToken: string;
    StandardCodeId: string;
}

export interface IListItemData {
    Id: string;
    Description: string;
    VisionToken: string;
    IsDisabled: boolean;
}


export interface SiteConfigurationOptions {
    ZipCodeMask: string;
}
export interface SkuAttributes {
    modelNumber: string;
    brandName: string;
    modelName: string;
    skuName: string;

    drumCapacity: string;
    combinedEF: string;
    fuelType: string;
    meetsMostEffcientCriteria: string;
    energyFactor: string;
    firstHourRating: string;

    storageCapacity: string;
    federalMEF: string;
    integratedMEF: string;
    loadConfiguration: string;
    cubicVolumeInFeet: string;
    percentBetter: string;
    energyStarType: string;
    defrostType: string;
    iceMaker: string;
    thruDoorDispenser: string;
    refrigeratorConfigType: string;
    dehumidifierType: string;
    removalCapacity: string;
    hasLouveredSides: string;
    reverseCycle: string;
    coolingCapacity: string;

    dustFreeCleanAirDeliveryCFM: string;
    smokeFreeCleanAirDeliveryCFM: string;
    pollenFreeCleanAirDeliveryCFM: string;
    dustFreeCleanAirDeliveryPerWatt: string;
    smokeFreeCleanAirDeliveryPerWatt: string;
    pollenFreeCleanAirDeliveryPerWatt: string;
}

export enum FieldEditableTypeCode {
    ReadOnly = 0,
    Editable = 1,
    ReadonlyOnEdit = 2,
    ReadonlyOnSSO = 3
}

export enum FieldDataTypeCode {
    Text = 1,
    Date = 2,
    Numeric = 3,
    EquipmentSelectList = 4,
    ApplicationSelectList = 5,  //Generic applcation lookup list
    ApplicationTypeList = 6,     //Application lookups that drive measure mix. (fuel types, project type, etc)
    ApplicationTierTypeList = 7,
    Dynamic = 10,
    Function = 15   //Field does not exist in UI. Used when tiering requires a field to trigger a function to retrieve tier value.
}

export interface RequiredFieldModel {
    IsEnabled: boolean;
    IsRequired: boolean;
    FieldName: string;
    LabelText: string | null;
    EditCode: number;
    UsageCode: number;
    FieldDataType: FieldDataTypeCode;
    IsEditable: FieldEditableTypeCode;
    HyperLinkText: string | null;
    ContextHelpText: string | null;
    ContextHelpTitle: string | null;
    PlaceholderText: string | null;

    HasMinValue: boolean;
    HasMaxValue: boolean;
    MinValue: number | null;
    MaxValue: number | null;
    HasDateMinValue: boolean;
    HasDateMaxValue: boolean;
    DateMinValue: Date | null;
    DateMaxValue: Date | null;
    ItemList: ApplicationListItem[] | null;
}

export interface FormFieldModel {
    IsEnabled: boolean;
    IsRequired: boolean;
    FieldName: string;
    LabelText: string | null;
    IsEditable: FieldEditableTypeCode;

    HasMinValue: boolean;
    HasMaxValue: boolean;
    MinValue: number | null;
    MaxValue: number | null;
    HasDateMinValue: boolean;
    HasDateMaxValue: boolean;
    DateMinValue: Date | null;
    DateMaxValue: Date | null;
}


export class UsageCode {
    static readonly FUT_Legacy: number = 0;
    static readonly FUT_Field: number = 1;      // Show/Hides, Updates Text, Set Jquery required field
    static readonly FUT_Title: number = 2;      // Updates text (can update to blank)
    static readonly FUT_Paragraph: number = 4;
    static readonly FUT_FieldSet: number = 3;    // Show/Hides field (does not update text, can be used to show or hide and type of markup)
    static readonly FUT_ReadOnlyField: number = 5;
    static readonly FUT_FieldRange: number = 6;      // Show/Hides, Updates Text, Set Jquery required field
    static readonly FUT_FieldDateRange: number = 7;      // Show/Hides, Updates Text, Set Jquery required field
    static readonly FUT_MappingOnly: number = 100;

    static readonly FT_Text: number = 1;
    static readonly FT_Date: number = 2;
    static readonly FT_Numeric: number = 3;
    static readonly FT_EquipmentSelectList: number = 4;
    static readonly FT_ApplicationSelectList: number = 5;
    static readonly FT_ApplicationTypeList: number = 6;
    static readonly FT_ApplicationTierTypeList: number = 7;
    static readonly FT_Dynamic: number = 10;
}


//This can be expanded but it will cover instantiating type ahead control 
//with these parameters
export interface ITypeAheadConfig {
    name: string, //Name of the type ahead reference
    url: string,  //The API URL for the TypesAhead control
    element: string,  //Text element
    displayField: string  //Field displayed to the use
    onSelectEvent: (event, selection) => any  //Would like to make this one optional...  but this is for the event 
}